import React from 'react';

import PropTypes from 'prop-types';
import Radio from '@tds/core-radio';

import Label from './label';
import { FieldOptionsGroup } from './css';
import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json'; 

const DefectCategory = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
        form: {
            labelDefectCategory,
            labelDefectCategoryOptionUserInfo,
            labelDefectCategoryOptionOffersPricing,
            labelDefectCategoryOptionBehaviouralIssue
          }
    }
  } = locale === 'en-US' ? EN : FR;
  const fieldError = 'defectCategory' in formErrors;
  const fieldOptions = [
    labelDefectCategoryOptionUserInfo,
    labelDefectCategoryOptionOffersPricing,
    labelDefectCategoryOptionBehaviouralIssue
  ];

  const handleSelect = ({ target: { value } }) => {
    if (value)
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.defectCategory;
        return updatedValues;
      });
    setFieldData(previousValue => ({
      ...previousValue,
      defectCategory: value
    }));
  };

  return (
    <div>
      <Label labelName={`${labelDefectCategory} *`} />
      {fieldError && (
        <div className="error-notification">
          <p>{formErrors.defectCategory.message}</p>
        </div>
      )}
      <FieldOptionsGroup>
        {fieldOptions.map(option => {
          return (
            <Radio
              checked={fieldData.defectCategory === option}
              onChange={handleSelect}
              name="defectCategory"
              value={option}
              label={option}
            />
          );
        })}
      </FieldOptionsGroup>
    </div>
  );
};

DefectCategory.propTypes = {
  formErrors: PropTypes.shape({
    defectCategory: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectCategory;
